import * as i0 from '@angular/core';
import * as i1 from './bs-datepicker.module';
import * as i2 from '@angular/common';
import * as i3 from './themes/bs/bs-datepicker-day-decorator.directive';
import * as i4 from './themes/bs/bs-current-date-view.component';
import * as i5 from './themes/bs/bs-datepicker-navigation-view.component';
import * as i6 from './themes/bs/bs-timepicker-view.component';
import * as i7 from './themes/bs/bs-calendar-layout.component';
import * as i8 from './themes/bs/bs-days-calendar-view.component';
import * as i9 from './themes/bs/bs-months-calendar-view.component';
import * as i10 from './themes/bs/bs-years-calendar-view.component';
import * as i11 from './themes/bs/bs-custom-dates-view.component';
import * as i12 from './themes/bs/bs-datepicker-container.component';
import * as i13 from './themes/bs/bs-daterangepicker-container.component';
import * as i14 from './bs-datepicker.component';
import * as i15 from './bs-datepicker-input.directive';
import * as i16 from './bs-daterangepicker-input.directive';
import * as i17 from './bs-daterangepicker.component';
export const BsDatepickerModuleNgFactory:i0.NgModuleFactory<i1.BsDatepickerModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.BsDatepickerDayDecoratorComponent = (<any>(null as any));
var _decl0_12:i4.BsCurrentDateViewComponent = (<any>(null as any));
var _decl0_13:i5.BsDatepickerNavigationViewComponent = (<any>(null as any));
var _decl0_14:i6.BsTimepickerViewComponent = (<any>(null as any));
var _decl0_15:i7.BsCalendarLayoutComponent = (<any>(null as any));
var _decl0_16:i8.BsDaysCalendarViewComponent = (<any>(null as any));
var _decl0_17:i9.BsMonthCalendarViewComponent = (<any>(null as any));
var _decl0_18:i10.BsYearsCalendarViewComponent = (<any>(null as any));
var _decl0_19:i11.BsCustomDatesViewComponent = (<any>(null as any));
var _decl0_20:i12.BsDatepickerContainerComponent = (<any>(null as any));
var _decl0_21:i13.BsDaterangepickerContainerComponent = (<any>(null as any));
var _decl0_22:i14.BsDatepickerDirective = (<any>(null as any));
var _decl0_23:i15.BsDatepickerInputDirective = (<any>(null as any));
var _decl0_24:i16.BsDaterangepickerInputDirective = (<any>(null as any));
var _decl0_25:i17.BsDaterangepickerDirective = (<any>(null as any));
var _decl0_26:i2.AsyncPipe = (<any>(null as any));
var _decl0_27:i2.UpperCasePipe = (<any>(null as any));
var _decl0_28:i2.LowerCasePipe = (<any>(null as any));
var _decl0_29:i2.JsonPipe = (<any>(null as any));
var _decl0_30:i2.SlicePipe = (<any>(null as any));
var _decl0_31:i2.DecimalPipe = (<any>(null as any));
var _decl0_32:i2.PercentPipe = (<any>(null as any));
var _decl0_33:i2.TitleCasePipe = (<any>(null as any));
var _decl0_34:i2.CurrencyPipe = (<any>(null as any));
var _decl0_35:i2.DatePipe = (<any>(null as any));
var _decl0_36:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_37:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_38:i2.CommonModule = (<any>(null as any));
var _decl0_39:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_40:i0.ElementRef<any> = (<any>(null as any));
function _View_BsDatepickerDayDecoratorComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.day.isDisabled;
  currVal_0;
  const currVal_1:any = _decl0_11.day.isHovered;
  currVal_1;
  const currVal_2:any = _decl0_11.day.isOtherMonth;
  currVal_2;
  const currVal_3:any = _decl0_11.day.isInRange;
  currVal_3;
  const currVal_4:any = _decl0_11.day.isSelectionStart;
  currVal_4;
  const currVal_5:any = _decl0_11.day.isSelectionEnd;
  currVal_5;
  const currVal_6:any = _decl0_11.day.isSelected;
  currVal_6;
}
function _View_BsDatepickerDayDecoratorComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.day.label;
  currVal_0;
}
function _View_BsCurrentDateViewComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_BsCurrentDateViewComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.title;
  currVal_0;
}
function _View_BsDatepickerNavigationViewComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_BsDatepickerNavigationViewComponent_3_1():void {
  if (_decl0_13.calendar.monthTitle) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_13.calendar.monthTitle;
    currVal_0;
    const pd_1:any = ((<any>_decl0_13.view('month')) !== false);
  }
}
function _View_BsDatepickerNavigationViewComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.calendar.disableLeftArrow;
  currVal_0;
  const currVal_1:any = (_decl0_13.calendar.hideLeftArrow? 'hidden': 'visible');
  currVal_1;
  const currVal_2:any = _decl0_13.calendar.monthTitle;
  currVal_2;
  const currVal_3:any = _decl0_13.calendar.yearTitle;
  currVal_3;
  const currVal_4:any = _decl0_13.calendar.disableRightArrow;
  currVal_4;
  const currVal_5:any = (_decl0_13.calendar.hideRightArrow? 'hidden': 'visible');
  currVal_5;
  const pd_6:any = ((<any>_decl0_13.navTo(true)) !== false);
  const pd_7:any = ((<any>_decl0_13.view('year')) !== false);
  const pd_8:any = ((<any>_decl0_13.navTo(false)) !== false);
}
function _View_BsTimepickerViewComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_BsTimepickerViewComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_14.hours;
  currVal_0;
  const currVal_1:any = _decl0_14.minutes;
  currVal_1;
  const currVal_2:any = _decl0_14.ampm;
  currVal_2;
}
function _View_BsCalendarLayoutComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_BsCalendarLayoutComponent_5_1():void {
  if (false) {
    var _any:any = (null as any);
    const currVal_0:any = 'hey there';
    currVal_0;
  }
}
function _View_BsCalendarLayoutComponent_5_2():void {
  if (false) { var _any:any = (null as any); }
}
function _View_BsCalendarLayoutComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = false;
  currVal_0;
  const currVal_1:any = false;
  currVal_1;
}
function _View_BsDaysCalendarViewComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_BsDaysCalendarViewComponent_6_1():void {
  if (_decl0_16.options.showWeekNumbers) { var _any:any = (null as any); }
}
function _View_BsDaysCalendarViewComponent_6_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.calendar.weekdays[_any];
  currVal_0;
}
function _View_BsDaysCalendarViewComponent_6_4():void {
  if (_decl0_16.options.showWeekNumbers) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_16.calendar.weekNumbers[_any];
    currVal_0;
  }
}
function _View_BsDaysCalendarViewComponent_6_5():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _decl0_11.day.isDisabled;
  currVal_1;
  const currVal_2:any = _decl0_11.day.isHovered;
  currVal_2;
  const currVal_3:any = _decl0_11.day.isOtherMonth;
  currVal_3;
  const currVal_4:any = _decl0_11.day.isInRange;
  currVal_4;
  const currVal_5:any = _decl0_11.day.isSelectionStart;
  currVal_5;
  const currVal_6:any = _decl0_11.day.isSelectionEnd;
  currVal_6;
  const currVal_7:any = _decl0_11.day.isSelected;
  currVal_7;
  const currVal_8:any = _any.label;
  currVal_8;
  const pd_9:any = ((<any>_decl0_16.selectDay(_any)) !== false);
  const pd_10:any = ((<any>_decl0_16.hoverDay(_any,true)) !== false);
  const pd_11:any = ((<any>_decl0_16.hoverDay(_any,false)) !== false);
}
function _View_BsDaysCalendarViewComponent_6_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.options.showWeekNumbers;
  currVal_0;
  const currVal_1:any = _any.days;
  currVal_1;
}
function _View_BsDaysCalendarViewComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.calendar;
  currVal_0;
  const currVal_1:any = _decl0_16.options.showWeekNumbers;
  currVal_1;
  const currVal_2:any = _decl0_16.calendar.weekdays;
  currVal_2;
  const currVal_3:any = _decl0_16.calendar.weeks;
  currVal_3;
  const pd_4:any = ((<any>_decl0_16.navigateTo(_any)) !== false);
  const pd_5:any = ((<any>_decl0_16.changeViewMode(_any)) !== false);
}
function _View_BsMonthCalendarViewComponent_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_BsMonthCalendarViewComponent_7_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.isDisabled;
  currVal_0;
  const currVal_1:any = _any.isHovered;
  currVal_1;
  const currVal_2:any = _any.label;
  currVal_2;
  const pd_3:any = ((<any>_decl0_17.viewMonth(_any)) !== false);
  const pd_4:any = ((<any>_decl0_17.hoverMonth(_any,true)) !== false);
  const pd_5:any = ((<any>_decl0_17.hoverMonth(_any,false)) !== false);
}
function _View_BsMonthCalendarViewComponent_7_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
}
function _View_BsMonthCalendarViewComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_17.calendar;
  currVal_0;
  const currVal_1:any = _decl0_17.calendar.months;
  currVal_1;
  const pd_2:any = ((<any>_decl0_17.navigateTo(_any)) !== false);
  const pd_3:any = ((<any>_decl0_17.changeViewMode(_any)) !== false);
}
function _View_BsYearsCalendarViewComponent_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_BsYearsCalendarViewComponent_8_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.isDisabled;
  currVal_0;
  const currVal_1:any = _any.isHovered;
  currVal_1;
  const currVal_2:any = _any.label;
  currVal_2;
  const pd_3:any = ((<any>_decl0_18.viewYear(_any)) !== false);
  const pd_4:any = ((<any>_decl0_18.hoverYear(_any,true)) !== false);
  const pd_5:any = ((<any>_decl0_18.hoverYear(_any,false)) !== false);
}
function _View_BsYearsCalendarViewComponent_8_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
}
function _View_BsYearsCalendarViewComponent_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_18.calendar;
  currVal_0;
  const currVal_1:any = _decl0_18.calendar.years;
  currVal_1;
  const pd_2:any = ((<any>_decl0_18.navigateTo(_any)) !== false);
  const pd_3:any = ((<any>_decl0_18.changeViewMode(_any)) !== false);
}
function _View_BsCustomDatesViewComponent_Host_9_0():void {
  var _any:any = (null as any);
}
function _View_BsCustomDatesViewComponent_9_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.label;
  currVal_0;
}
function _View_BsCustomDatesViewComponent_9_2():void {
  if (_decl0_19.isCustomRangeShown) { var _any:any = (null as any); }
}
function _View_BsCustomDatesViewComponent_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_19.ranges;
  currVal_0;
  const currVal_1:any = _decl0_19.isCustomRangeShown;
  currVal_1;
}
function _View_BsDatepickerContainerComponent_Host_10_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_20._stopPropagation(_any)) !== false);
}
function _View_BsDatepickerContainerComponent_10_3():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    const currVal_1:any = _decl0_26.transform(_decl0_20.options);
    currVal_1;
    var tmp_2_0:any = (null as any);
    const currVal_2:any = ((((tmp_2_0 = _decl0_26.transform(_decl0_20.daysCalendar)) == null)? (null as any): tmp_2_0.length) > 1);
    currVal_2;
    const pd_3:any = ((<any>_decl0_20.navigateTo(_any)) !== false);
    const pd_4:any = ((<any>_decl0_20.setViewMode(_any)) !== false);
    const pd_5:any = ((<any>_decl0_20.dayHoverHandler(_any)) !== false);
    const pd_6:any = ((<any>_decl0_20.daySelectHandler(_any)) !== false);
  }
}
function _View_BsDatepickerContainerComponent_10_2():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_26.transform(_decl0_20.daysCalendar);
    currVal_0;
  }
}
function _View_BsDatepickerContainerComponent_10_5():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    var tmp_1_0:any = (null as any);
    const currVal_1:any = ((((tmp_1_0 = _decl0_26.transform(_decl0_20.daysCalendar)) == null)? (null as any): tmp_1_0.length) > 1);
    currVal_1;
    const pd_2:any = ((<any>_decl0_20.navigateTo(_any)) !== false);
    const pd_3:any = ((<any>_decl0_20.setViewMode(_any)) !== false);
    const pd_4:any = ((<any>_decl0_20.monthHoverHandler(_any)) !== false);
    const pd_5:any = ((<any>_decl0_20.monthSelectHandler(_any)) !== false);
  }
}
function _View_BsDatepickerContainerComponent_10_4():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_26.transform(_decl0_20.monthsCalendar);
    currVal_0;
  }
}
function _View_BsDatepickerContainerComponent_10_7():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    var tmp_1_0:any = (null as any);
    const currVal_1:any = ((((tmp_1_0 = _decl0_26.transform(_decl0_20.daysCalendar)) == null)? (null as any): tmp_1_0.length) > 1);
    currVal_1;
    const pd_2:any = ((<any>_decl0_20.navigateTo(_any)) !== false);
    const pd_3:any = ((<any>_decl0_20.setViewMode(_any)) !== false);
    const pd_4:any = ((<any>_decl0_20.yearHoverHandler(_any)) !== false);
    const pd_5:any = ((<any>_decl0_20.yearSelectHandler(_any)) !== false);
  }
}
function _View_BsDatepickerContainerComponent_10_6():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_26.transform(_decl0_20.yearsCalendar);
    currVal_0;
  }
}
function _View_BsDatepickerContainerComponent_10_8():void {
  if ((_decl0_26.transform(_decl0_20.viewMode) && false)) { var _any:any = (null as any); }
}
function _View_BsDatepickerContainerComponent_10_9():void {
  if ((_decl0_26.transform(_decl0_20.viewMode) && false)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_20._customRangesFish;
    currVal_0;
  }
}
function _View_BsDatepickerContainerComponent_10_1():void {
  if (_decl0_26.transform(_decl0_20.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = 'bs-datepicker';
    currVal_0;
    const currVal_1:any = _decl0_20.containerClass;
    currVal_1;
    const currVal_2:any = _decl0_26.transform(_decl0_20.viewMode);
    currVal_2;
    const currVal_3:any = 'day';
    currVal_3;
    const currVal_4:any = 'month';
    currVal_4;
    const currVal_5:any = 'year';
    currVal_5;
    const currVal_6:any = false;
    currVal_6;
    const currVal_7:any = false;
    currVal_7;
  }
}
function _View_BsDatepickerContainerComponent_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_26.transform(_decl0_20.viewMode);
  currVal_0;
}
function _View_BsDaterangepickerContainerComponent_Host_11_0():void {
  var _any:any = (null as any);
  const pd_0:any = ((<any>_decl0_21._stopPropagation(_any)) !== false);
}
function _View_BsDaterangepickerContainerComponent_11_3():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    const currVal_1:any = _decl0_26.transform(_decl0_21.options);
    currVal_1;
    var tmp_2_0:any = (null as any);
    const currVal_2:any = ((((tmp_2_0 = _decl0_26.transform(_decl0_21.daysCalendar)) == null)? (null as any): tmp_2_0.length) > 1);
    currVal_2;
    const pd_3:any = ((<any>_decl0_21.navigateTo(_any)) !== false);
    const pd_4:any = ((<any>_decl0_21.setViewMode(_any)) !== false);
    const pd_5:any = ((<any>_decl0_21.dayHoverHandler(_any)) !== false);
    const pd_6:any = ((<any>_decl0_21.daySelectHandler(_any)) !== false);
  }
}
function _View_BsDaterangepickerContainerComponent_11_2():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_26.transform(_decl0_21.daysCalendar);
    currVal_0;
  }
}
function _View_BsDaterangepickerContainerComponent_11_5():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    var tmp_1_0:any = (null as any);
    const currVal_1:any = ((((tmp_1_0 = _decl0_26.transform(_decl0_21.daysCalendar)) == null)? (null as any): tmp_1_0.length) > 1);
    currVal_1;
    const pd_2:any = ((<any>_decl0_21.navigateTo(_any)) !== false);
    const pd_3:any = ((<any>_decl0_21.setViewMode(_any)) !== false);
    const pd_4:any = ((<any>_decl0_21.monthHoverHandler(_any)) !== false);
    const pd_5:any = ((<any>_decl0_21.monthSelectHandler(_any)) !== false);
  }
}
function _View_BsDaterangepickerContainerComponent_11_4():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_26.transform(_decl0_21.monthsCalendar);
    currVal_0;
  }
}
function _View_BsDaterangepickerContainerComponent_11_7():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    var tmp_1_0:any = (null as any);
    const currVal_1:any = ((((tmp_1_0 = _decl0_26.transform(_decl0_21.daysCalendar)) == null)? (null as any): tmp_1_0.length) > 1);
    currVal_1;
    const pd_2:any = ((<any>_decl0_21.navigateTo(_any)) !== false);
    const pd_3:any = ((<any>_decl0_21.setViewMode(_any)) !== false);
    const pd_4:any = ((<any>_decl0_21.yearHoverHandler(_any)) !== false);
    const pd_5:any = ((<any>_decl0_21.yearSelectHandler(_any)) !== false);
  }
}
function _View_BsDaterangepickerContainerComponent_11_6():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_26.transform(_decl0_21.yearsCalendar);
    currVal_0;
  }
}
function _View_BsDaterangepickerContainerComponent_11_8():void {
  if ((_decl0_26.transform(_decl0_21.viewMode) && false)) { var _any:any = (null as any); }
}
function _View_BsDaterangepickerContainerComponent_11_9():void {
  if ((_decl0_26.transform(_decl0_21.viewMode) && false)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_21._customRangesFish;
    currVal_0;
  }
}
function _View_BsDaterangepickerContainerComponent_11_1():void {
  if (_decl0_26.transform(_decl0_21.viewMode)) {
    var _any:any = (null as any);
    const currVal_0:any = 'bs-datepicker';
    currVal_0;
    const currVal_1:any = _decl0_21.containerClass;
    currVal_1;
    const currVal_2:any = _decl0_26.transform(_decl0_21.viewMode);
    currVal_2;
    const currVal_3:any = 'day';
    currVal_3;
    const currVal_4:any = 'month';
    currVal_4;
    const currVal_5:any = 'year';
    currVal_5;
    const currVal_6:any = false;
    currVal_6;
    const currVal_7:any = false;
    currVal_7;
  }
}
function _View_BsDaterangepickerContainerComponent_11_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_26.transform(_decl0_21.viewMode);
  currVal_0;
}
